import * as actionTypes from "../../../../actionTypes";
import * as api from "../../../../../api/index";

export const GetContactsBIZfusionCC = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  let res, statusCode;
  try {
    const { data, status } = await api.getContactsBIZfusionCC(page, limit, query);
    res = data;
    statusCode = status;
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CONTACTS_BIZ_FUSION_CC, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
  return { res, statusCode };
};